var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-stacking": ""
    },
    on: {
      "hide": _vm.onHide
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "cols": "10"
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "exclamation-triangle",
      "variant": "warning",
      "font-scale": "1.5"
    }
  }), _c('h2', {
    staticClass: "h2 heading mb-0"
  }, [_vm._v(" Convert to Permanent Reassignment? ")])], 1), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-alert', {
    attrs: {
      "variant": "warning"
    },
    model: {
      value: _vm.alert.show,
      callback: function ($$v) {
        _vm.$set(_vm.alert, "show", $$v);
      },
      expression: "alert.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "offset": "2"
    }
  }, [_c('b-row', {
    staticClass: "mt-2 pr-4"
  }, [_c('b-col', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" This will convert the temporary reassignment into a permanent one — patients will stay with the receiving doctor(s) instead of returning to the original doctor. ")])])], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Source Doctor")]), _c('br'), _c('span', [_vm._v("Dr. " + _vm._s(_vm.rowData.firstname || '') + " " + _vm._s(_vm.rowData.lastname || ''))])])], 1), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Reassigned To")]), _c('br'), _vm.doctors.length ? [_c('ul', {
    staticClass: "doctor-list"
  }, _vm._l(_vm.doctors.slice(0, 5), function (doctor) {
    return _c('li', {
      key: doctor.doctorid
    }, [_vm._v(" Dr. " + _vm._s(doctor.firstname) + " " + _vm._s(doctor.lastname) + " ")]);
  }), 0), _vm.doctors.length > 5 ? [_c('span', {
    staticClass: "overflow-link text-secondary",
    attrs: {
      "id": `permanent-doctor-more-${_vm.rowData.id}`
    }
  }, [_vm._v(" +" + _vm._s(_vm.doctors.length - 5) + " more ")]), _c('b-popover', {
    attrs: {
      "target": `permanent-doctor-more-${_vm.rowData.id}`,
      "triggers": "hover",
      "placement": "top",
      "boundary": "window",
      "custom-class": "doctor-overflow-popover"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.doctors.length - 5) + " more doctors ")];
      },
      proxy: true
    }], null, false, 1368277199)
  }, [_c('ul', {
    staticClass: "doctor-list doctor-overflow-list"
  }, _vm._l(_vm.doctors.slice(5), function (doctor) {
    return _c('li', {
      key: doctor.doctorid
    }, [_vm._v(" Dr. " + _vm._s(doctor.firstname) + " " + _vm._s(doctor.lastname) + " ")]);
  }), 0)])] : _vm._e()] : _c('span', [_vm._v("—")])], 2)], 1), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Current End Date")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.currentEndDateLabel) + " "), _c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("(will be removed)")])])])], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" This action cannot be undone. ")])])], 1), _c('b-row', {
    staticClass: "mt-5"
  }, [_c('b-col', [_c('b-button', {
    ref: "cancelBtn",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.buttonDisabled,
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "danger",
      "disabled": _vm.buttonDisabled,
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.confirmConvert
    }
  }, [_vm._v(" Convert to Permanent ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };